exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#helloWorld[data-v-29fa7a92] {\n  font-family: 'Avenir', Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-align: center;\n  color: #2c3e50;\n  margin-top: 60px;\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.logo[data-v-29fa7a92] {\n  height: 144px;\n  width: 144px;\n}\nh3[data-v-29fa7a92] {\n  margin: 40px 0 0;\n}\nul[data-v-29fa7a92] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-29fa7a92] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-29fa7a92] {\n  color: #42b983;\n}\n.contact[data-v-29fa7a92] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29fa7a92","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/HelloWorld.vue
// module id = 4PJr
// module chunks = 1